<template>
	<div class="container pt-6 pb-10 min-h-full">

		<div class="h-full flex flex-row justify-between gap-10">
			<div class="w-1/2">
				<h2 class="text-3xl font-medium mb-10">Module</h2>
				<div class="flex gap-2">
					<v-text-field v-model="module.width" label="Latime gol" outlined suffix="mm"></v-text-field>
					<v-text-field v-model="module.height" label="Inaltime gol" outlined suffix="mm"></v-text-field>
				</div>
				<div class="flex gap-2">

					<v-btn @click="isFrame = !isFrame">Add Frame</v-btn>
					<v-btn @click="addSlat">Add Slat</v-btn>
					<v-btn @click="saveImage">Save</v-btn>
					<v-btn @click="resetCanvas">Reset</v-btn>
				</div>
				<div>
					is Frame: {{ isFrame }}
				</div>
				<div>{{ ratio }}</div>
				<pre>

					{{ canvasWidth }} - {{ canvasHeight }}
					{{ nextSlatStart }}
					{{ shapes.length }}
					{{ shapes }}
				</pre>
			</div>
			<div class="w-1/2 pt-4">
				<div class="flex justify-center py-4">
					<div class="">{{ module.width }} mm</div>
				</div>
				<div class="flex justify-center">
					<v-stage v-if="ratio < 4" ref="module" :config="{ width: canvasWidth, height: canvasHeight }"
						class="bg-white mx-auto">
						<v-layer>
							<component v-for="shape in shapes" v-bind:is="shape.type" :key="shape.id"
								:config="shape.config">
							</component>
						</v-layer>
					</v-stage>
					<v-alert v-else type="warning">Verifica dimensiunile golului</v-alert>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			module: {
				width: null,
				height: null
			},
			uProfileSize: 5,
			slatSize: 10,
			slatCount: 1,
			slatsList: [],
			shapesList: [],
			isFrame: false,
			canvasConfig: {
				width: 600,
				height: 400
			},
			dimensions: {
				frameSize: 70,
				uProfileSize: 20,
			}
		};
	},
	computed: {
		ratio() {
			return this.module.width / this.module.height
		},
		canvasWidth() {
			if (this.ratio < 1) {
				return (this.module.width / this.scale)
			} else {
				return 600
			}
		},
		canvasHeight() {
			if (this.ratio < 1) {
				return (this.module.height * this.ratio)
			} else {
				return (this.module.height / this.scale)
			}
		},
		scale() {
			if (this.ratio < 1) {
				return this.module.height / this.canvasHeight
			} else {
				return this.module.width / this.canvasWidth
			}
		},
		nextSlatStart() {
			return {
				x: this.isFrame ? 15 : 5,
				y: (this.slatSize + this.isFrame ? 15 : 5) * (this.slatsList.length)
			}
		},
		uProfilesArr() {
			return [
				{
					id: 'first_u_profile',
					type: 'v-rect',
					config: {
						x: this.isFrame ? 10 : 1,
						y: this.isFrame ? 10 : 1,
						width: this.uProfileSize,
						height: this.isFrame ? 380 : 400 - 1,
						fill: "#d5d5d5",
						stroke: "red",
						strokeWidth: 1
					}
				},
				{
					id: 'second_u_profile',
					type: 'v-rect',
					config: {
						x: this.isFrame ? 585 : 595,
						y: this.isFrame ? 10 : 1,
						width: this.uProfileSize,
						height: this.isFrame ? 380 : 400 - 1,
						fill: "#d5d5d5",
						stroke: "red",
						strokeWidth: 1
					}
				}
			]
		},
		shapes: {
			get() {
				// concat order is important to respect z-index of elements
				return this.slatsList.concat(this.uProfilesArr, this.shapesList)
			},
			set(newVal) {
				this.shapesList = newVal
			}
		}
	},
	watch: {
		isFrame(newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal) {
					this.shapesList = []
					this.addFrame()
				} else {
					this.removeFrame()
				}
				this.updateSlatsWidth()
			}
		},
		// ratio(newVal, oldVal) {
		// 	if (newVal != oldVal) {
		// 		if (newVal < 1) {
		// 			console.log('recalculate width')
		// 		}
		// 	}
		// },
		// 'module.height'(newVal, oldVal) {
		// 	if (newVal != oldVal) {
		// 		this.canvasConfig.height = this.module.height / this.scale
		// 	}
		// }
	},
	methods: {
		addFrame() {
			this.shapesList.push({
				id: 'frame-top',
				type: 'v-line',
				config: {
					points: [1, 1, 600, 1, 600 - 10, 10, 10, 10],
					fill: "#d5d5d5",
					stroke: "blue",
					strokeWidth: 1,
					closed: true
				}
			},
				{
					id: 'frame-right',
					type: 'v-line',
					config: {
						points: [600 - 10, 10, 600, 1, 600, 400, 600 - 10, 400 - 10],
						fill: "#d5d5d5",
						stroke: "blue",
						strokeWidth: 1,
						closed: true
					}
				},
				{
					id: 'frame-bottom',
					type: 'v-line',
					config: {
						points: [10, 400 - 10, 600 - 10, 400 - 10, 600, 400, 1, 400],
						fill: "#d5d5d5",
						stroke: "blue",
						strokeWidth: 1,
						closed: true
					}
				},
				{
					id: 'frame-left',
					type: 'v-line',
					config: {
						points: [1, 1, 10, 10, 10, 400 - 10, 1, 400],
						fill: "#d5d5d5",
						stroke: "blue",
						strokeWidth: 1,
						closed: true
					}
				}
			)
		},
		removeFrame() {
			const frameElementIds = ['frame-top', 'frame-right', 'frame-bottom', 'frame-left']
			frameElementIds.forEach(frameEl => {
				const el = (item) => item.id == frameEl
				const idx = this.shapesList.findIndex(el)
				if (idx > -1) {
					this.shapesList.splice(idx, 1);
				}

			})
		},
		addSlat() {
			this.slatsList.push({
				id: 'slat-' + this.slatCount++,
				type: 'v-rect',
				config: {
					x: this.nextSlatStart.x,
					y: this.nextSlatStart.y,
					width: this.isFrame ? 570 : 590,
					height: this.slatSize,
					fill: "grey",
					stroke: "black",
					strokeWidth: 1
				}
			})
		},
		updateSlatsWidth() {
			this.slatsList.forEach(slat => {
				slat.config.x = this.isFrame ? 15 : 5
				slat.config.width = this.isFrame ? 570 : 590
			})
		},
		resetCanvas() {
			this.isFrame = false
			this.slatsList = []
			this.slatCount = 1
		},
		saveImage() {
			const stage = this.$refs.module.getNode()
			const dataURL = stage.toDataURL()
			const link = document.createElement('a');
			link.download = 'image.png';
			link.href = dataURL;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}
};
</script>

<style scoped></style>
